var _rect, _rect2, _rect3, _rect4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#E4E4E4",
    fillOpacity: 0.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: -7461,
    y: -15824,
    width: 25990,
    height: 17640,
    stroke: "black",
    strokeOpacity: 0.7,
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "80 80"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -1106,
    y: -565,
    width: 1999,
    height: 2063,
    rx: 40,
    fill: "#080717"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1999,
    height: 1264,
    transform: "translate(-1106 -485)",
    fill: "#030116"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_501_117)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -826.5,
    y: -365,
    width: 1440,
    height: 1024,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_501_117)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -827,
    y: -365,
    width: 1440,
    height: 1024,
    fill: "black",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_501_117)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -194,
    y: -118,
    width: 412,
    height: 350,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 348,
    height: 126,
    transform: "translate(-162 -12)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 0.333252C5.56065 0.333252 0.333984 5.55992 0.333984 11.9999C0.333984 18.4399 5.56065 23.6666 12.0007 23.6666C18.4407 23.6666 23.6673 18.4399 23.6673 11.9999C23.6673 5.55992 18.4407 0.333252 12.0007 0.333252ZM12.0007 21.3333C6.85565 21.3333 2.66732 17.1449 2.66732 11.9999C2.66732 6.85492 6.85565 2.66659 12.0007 2.66659C17.1457 2.66659 21.334 6.85492 21.334 11.9999C21.334 17.1449 17.1457 21.3333 12.0007 21.3333ZM16.5273 7.67159L9.66732 14.5316L7.47398 12.3383C7.01898 11.8833 6.28398 11.8833 5.82898 12.3383C5.37398 12.7933 5.37398 13.5283 5.82898 13.9833L8.85065 17.0049C9.30565 17.4599 10.0407 17.4599 10.4957 17.0049L18.184 9.31659C18.639 8.86159 18.639 8.12659 18.184 7.67159C17.729 7.21659 16.9823 7.21659 16.5273 7.67159Z",
    fill: "#1FE08F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_501_117",
    x: -835,
    y: -373,
    width: 1456,
    height: 1040,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_501_117"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_501_117",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_501_117",
    x: -218,
    y: -140,
    width: 460,
    height: 398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_501_117"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_501_117",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_501_117"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -826.5,
    y: -365,
    width: 1440,
    height: 1024,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.f235631ceefdb8c16392c6420429773a.svg";
export { ForwardRef as ReactComponent };